import { createFileRoute } from '@tanstack/react-router';

import { ContactNumberPage } from '@/features/help-support/ContactNumberPage';
import type { HelpSupportTab } from '@/features/help-support/help-support-presentation';
import { TutorialVideosPage } from '@/features/help-support/TutorialVideosPage';

interface HelpSupportSearch {
  tab: HelpSupportTab;
}

function HelpSupportRoute() {
  const { tab } = Route.useSearch();
  return (
    <>
      <div hidden={tab !== 'TUTORIALS'}>
        <TutorialVideosPage />
      </div>
      <div hidden={tab !== 'CONTACT'}>
        <ContactNumberPage />
      </div>
    </>
  );
}

export const Route = createFileRoute('/admin/_app/tutorials')({
  validateSearch: (search: Record<string, unknown>): HelpSupportSearch => ({
    tab: search['tab'] === 'CONTACT' ? 'CONTACT' : 'TUTORIALS',
  }),
  component: HelpSupportRoute,
});
